import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

// Domain components
import GlobalTalentVisa from '../domain/global_talent_visa/components/GlobalTalentVisa';
import { PersonalStatementGenerator } from '../domain/global_talent_visa/components';
import ProfileScoreAnalyzer from '../domain/global_talent_visa/components/ProfileScoreAnalyzer';
import TouristVisa from '../domain/tourist_visa/components/TouristVisa';

// For now, we'll use the main components which already have chat functionality
// We'll create separate chat components later if needed

const VisaRoutes: React.FC = () => {
    return (
        <Routes>
            {/* Personal Statement Generator - Top Level */}
            <Route path="personal-statement" element={<PersonalStatementGenerator />} />

            {/* GTV Eligibility Checker - Top Level */}
            <Route path="gtv-eligibility-checker" element={<ProfileScoreAnalyzer />} />

            {/* Global Talent Visa Domain */}
            <Route path="global-talent-visa">
                {/* Main visa page */}
                <Route index element={<GlobalTalentVisa />} />

                {/* Chat routes */}
                <Route path="chat" element={<GlobalTalentVisa />} />
                <Route path="chat/:sessionId" element={<GlobalTalentVisa />} />
            </Route>

            {/* Tourist Visa Domain */}
            <Route path="tourist-visa">
                {/* Main visa page */}
                <Route index element={<TouristVisa />} />

                {/* Chat routes */}
                <Route path="chat" element={<TouristVisa />} />
                <Route path="chat/:sessionId" element={<TouristVisa />} />
            </Route>

            {/* Default redirect to global talent visa */}
            <Route path="" element={<Navigate to="global-talent-visa" replace />} />

            {/* Catch-all for unknown visa routes */}
            <Route path="*" element={<Navigate to="global-talent-visa" replace />} />
        </Routes>
    );
};

export default VisaRoutes; 